<template>
<v-list-tile >
  <v-list-tile-avatar v-if='exercise.adherence' >
    <adherence-progress v-model='exercise.adherence' ></adherence-progress>
  </v-list-tile-avatar>
  <v-list-tile-content>
    <v-list-tile-title >
      {{exercise.name}}
    </v-list-tile-title>
    <v-list-tile-sub-title >
      <template v-for='field in fields' >
        <v-chip outline outlined label
          :key='`${field}-${exercise.id}`'
          v-if='getAdherence(field) || getField(field)'
          class='v-chip--x-small pa-0 ml-1' >
          <span v-if='exercise.adherence'  >
            <strong>{{field}}:</strong> {{ getAdherence(field) }}
          </span>
          <span v-else >
            <strong>{{field}}:</strong> {{ getField(field) }}
          </span>
        </v-chip>
      </template>
      <!-- <strong>Reps:</strong> {{exercise.reps_assigned}}
      <span v-if='exercise.duration_assigned' >Hold: {{exercise.duration_assigned}}</span> -->
    </v-list-tile-sub-title>
  </v-list-tile-content>
  <v-list-tile-action v-if='exercise.pain_level' >
    <!-- <v-chip class="v-chip--x-small" color='error' dark label >
      Pain
      {{exercise.pain_level}}
    </v-chip> -->
    <v-progress-circular
      color='error' width='3' size='26'
      :value='exercise.pain_level * 10' >
      {{exercise.pain_level}}
    </v-progress-circular>

  </v-list-tile-action>
</v-list-tile>
</template>
<script>
import AdherenceProgress from './AdherenceProgress.vue'
export default {
  name: 'ExerciseListItem',
  components: {AdherenceProgress},
  props: {
    value: { type: Object, required: true }
  },
  data () {
    return {
      exercise: {},
      fields: [
        'reps', 'rpe', 'sets', 'hold', 'thr', 'weight'
      ]
    }
  },
  methods: {
    getField (field) {
      if (field in this.value && this.value[field]) {
        return this.value[field]
      }
      return null
    },
    getAdherence (field) {
      let assignedField = field + '_assigned'
      let completedField = field + '_completed'
      if (assignedField in this.value && completedField in this.value) {
        return `${this.value[completedField]}/${this.value[assignedField]}`
      }
      return null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) { this.exercise = this.value }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ExerciseListItem.vue?f282589e